import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { blog } from "@/lib/api";
import { BookOpen, ArrowRight, Download, Clock } from "lucide-react";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog & Recursos — Kursos Online";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Guías tácticas, playbooks y recursos gratuitos para emprender, vender e invertir. Aprende con Kursos Online."
      );
    blog.list().then(setPosts).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="blog-page" className="bg-white min-h-[80vh]">
      <section className="bg-zinc-950 text-white relative overflow-hidden">
        <div className="absolute inset-0 grain pointer-events-none" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 relative">
          <div className="flex items-center gap-2 mb-4">
            <BookOpen className="w-4 h-4 text-[#10B981]" />
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#10B981]">Recursos gratuitos</p>
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter max-w-3xl">
            Playbooks y guías que{" "}
            <span className="bg-gradient-to-r from-indigo-400 via-violet-300 to-emerald-400 bg-clip-text text-transparent">
              convierten conocimiento en resultados
            </span>
          </h1>
          <p className="mt-6 text-zinc-400 text-lg max-w-xl">
            Estrategias accionables de marketing, ventas, IA y crecimiento. Descarga los recursos en PDF y aplícalos hoy.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        {loading ? (
          <p className="text-zinc-500">Cargando artículos...</p>
        ) : posts.length === 0 ? (
          <div data-testid="blog-empty" className="text-center py-20 border border-zinc-200">
            <BookOpen className="w-10 h-10 mx-auto text-zinc-400 mb-4" />
            <h3 className="font-display font-bold text-xl mb-2">Pronto habrá nuevos recursos</h3>
            <p className="text-zinc-600">Estamos preparando guías increíbles para ti.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group flex flex-col border border-zinc-200 hover:border-[#4F46E5] transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-indigo-500/10"
              >
                {p.cover_image ? (
                  <div className="aspect-[16/9] overflow-hidden bg-zinc-100">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                ) : (
                  <div className="aspect-[16/9] bg-gradient-to-br from-indigo-950 via-slate-900 to-emerald-950" />
                )}
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-[11px] uppercase tracking-wider font-bold text-[#4F46E5]">{p.category}</span>
                    {p.is_lead_magnet && (
                      <span className="inline-flex items-center gap-1 text-[11px] font-bold text-[#10B981]">
                        <Download className="w-3 h-3" /> PDF
                      </span>
                    )}
                  </div>
                  <h2 className="font-display font-bold text-xl leading-snug mb-2 group-hover:text-[#4F46E5] transition-colors">{p.title}</h2>
                  {p.subtitle && <p className="text-sm text-zinc-600 mb-4 line-clamp-2">{p.subtitle}</p>}
                  <div className="mt-auto flex items-center justify-between pt-4 text-xs text-zinc-500">
                    <span className="inline-flex items-center gap-1">
                      <Clock className="w-3 h-3" /> {(p.published_at || "").slice(0, 10)}
                    </span>
                    <span className="inline-flex items-center gap-1 font-semibold text-zinc-900 group-hover:text-[#4F46E5]">
                      Leer <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </main>
  );
};

export default Blog;
